<template>
  <div class="pane-wrapper">
    <div class="pane" :class="['typed', `typed--${type}`]" ref="pane" v-debounce:100="debouncedWheeled" :debounce-events="'wheel'" @wheel="wheeled">
      <Foo :content="body" :index="index" :writable="true" v-on:indexed="selectSegment"></Foo>
    </div>

    <div class="pane-toolbar" v-hotkey="keymap" v-if="segments">
      <KeyNav :keyLevel="3" :size="segments.length" :defaultIndex="index" @selected="selectSegment">
        <b-button @click="decreaseSegment">
          <b-icon-dash></b-icon-dash>
        </b-button>

        <span class="pane-toolbar__current">{{ index + 1 }} / {{ segments.length }}</span>

        <b-button @click="increaseSegment">
          <b-icon-plus></b-icon-plus>
        </b-button>
      </KeyNav>
    </div>
  </div>
</template>

<script>
  import KeyNav from '../components/KeyNav'
  import Foo from '../components/Foo';

  export default {
    props: {
      type: {
        type: String,
        required: true
      },

      body: {
        type: String
      },

      segments: {
        type: Array
      }
    },

    components: { KeyNav, Foo },

    data() {
      return {
        index: 0
      }
    },

    computed: {
      keymap() {
        return {
          'up': this.decreaseSegment,
          'down': this.increaseSegment
        }
      }
    },

    watch: {
      body() {
        this.index = 0;
      },

      index() {
        this.$emit('positioned', this.index)
      }
    },

    methods: {
      wheeled(e) {
        e.preventDefault();
        return;
      },

      debouncedWheeled(_, e) {
        if (e.deltaY > 0) {
          this.increaseSegment();
        } else {
          this.decreaseSegment();
        }
      },

      decreaseSegment() {
        if (this.segments) {
          if (this.index !== 0) {
            this.index--;
          }
        }
      },

      increaseSegment() {
        if (this.segments) {
          if (this.index !== this.segments.length - 1) {
            this.index++;
          }
        }
      },

      selectSegment(index) {
        this.index = index;
      }
    }
  }
</script>

<style scoped>
  .pane-wrapper {
    position: absolute;
    height: 100%;
    width: 100%;

    border-top: 1px solid #eee;
    border-bottom: 1px solid #ccc;
  }

  .pane {
    position: absolute;
    height: calc(100% - 3em);
    width: 100%;

    overflow-y: auto;
  }

  .pane {
    font-size: 1.5em;
  }
  
  .pane.typed--song .pane {
    padding: 0;
  }

  .pane-toolbar {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 3em;

    background: #CCC;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pane-toolbar__current {
    display: inline-block;
    padding: 0 2em;

    text-align: center;
    font-weight: bold;
  }

  .pane /deep/ .ql-font-serif {
    font-family: Georgia, 'Times New Roman', Times, serif;
  }
</style>